import server from '../../plugins/server'
import $f from '../../plugins/functions'
import countries from '../../assets/data/countries.json'
import _ from 'lodash';
import reduxStore from '../../store';
export default {
    namespaced: true,
    state() {
        return {
           warhouseSelected: localStorage.getItem('countryW') || 'CI',
           sous_warhouseSelected: localStorage.getItem('sous_countryW') || 'all',
           changeW_sous:false,
           changeW:false,
           warhouses:[],
           options:countries,
           warehouses:[],
           sous_warehouses:[],
           warehousesUser:[],
           warehousesSeller:[],
        };
    },

    mutations: {
        changeWrahouse: function(state, payload) {
            if(payload.type=='principal'){
                state.warhouseSelected=payload.warhouse;
                state.changeW=true;
            }else{
                state.sous_warhouseSelected=payload.warhouse;
                state.changeW_sous=true;
            }
            console.log('event target changeWrahouse---',payload)
        },
        getWarehouses: function(state, payload) {
            state.user=payload.user;
            console.log('event target value user_______________',payload.user)
        },
    },
    actions: {
        changeWrahouse(context, payload) {
            context.commit('changeWrahouse', payload);
        },
        // async getwharhouseId({commit}, payload){
        //     //console.log('get warhouse',payload)
        //     const resW = await server.get("warehouses", { country:payload.country}); 
        //    //console.log('resW warhouse',resW)
        //     if(resW && resW.content) return  resW.content;
        // },
        async getwharhouseId({getters},payload){
            const resW = await server.get("warehouses", {country: payload.country}); 
            if(resW.content) return  resW.content;
        },
        async getCurrency({getters,state},payload){
           if(state.warehouses && state.warhouseSelected) {
               const dataW=state.warehouses.find(o => o.country === state.warhouseSelected);
               if(dataW) return dataW.currency; 
           }
        },
        async getwharhouseSeller(){
            const resW = await server.get("products", { allWarhouseSeller: true}); 
            return resW.content;
        },
        async searchUser({commit}, payload){
            if(payload.type!='zone'){
                const filter = {
                    type: payload.type[0].toUpperCase() + payload.type.slice(1),
                    limit:10,
                    warehouses: payload.warhouse,
                    name: payload.search,
                };  
                console.log('filter w',filter)
                const res= await server.find("users",filter);   
                console.log('res w',res.content)
                if (res.content) return res.content;
                else return [];
           }else{
                const filter = {
                    limit:10,
                    warehouse: payload.warhouse,
                    name: payload.search,
                };  
                console.log('filter w',filter)
                const res= await server.find("zones",filter);   
                console.log('res w',res.content)
                if (res && res.content.results) return res.content.results;
                else return [];
           }
        },
        async searchProducts({commit}, payload){
            const filter = {
                limit:10,
                seller: payload.seller,
                'details.warehouse': payload.warhouse,
                name: payload.search,
                notPopulate:true 
            };  
            console.log('filter w',filter)
            const res= await server.find("products",filter);   
            console.log('res ppppp',res)
            if (res.content && res.content.results) return res.content.results;
            else return [];
        },
        // async getWarehouses({commit, state},payload){
        //     const filter = {limit:1000};
        //     state.warehouses=[];
        //     state.warehousesUser=[];
        //     if(payload.user.warehouses) state.warehousesUser = payload.user.warehouses; 

        //     if(state.warehousesUser.length>0) state.warehouses= state.warehousesUser;
        //     else{
        //       const res = await server.search("warehouses",filter);
        //       if (res.content.results) state.warehouses=res.content.results;
        //       else state.warehouses = [];
        //   }
        //   return  state.warehouses;
        // },
        async getWarehouses({commit, state},payload){
            commit('getWarehouses', payload);
            const filter = {limit:1000};
            state.warehouses=state.sous_warehouses=state.warehousesUser=[];
            console.log('stat user -------',state.user)
            if (state.user){
                if(state.user.warehouses) state.warehousesUser = state.user.warehouses;
                if(state.user.sous_warehouses && state.user.sous_warehouses.length>0) state.sous_warehouses = state.user.sous_warehouses;
            } 

            if(state.warehousesUser.length>0) state.warehouses= state.warehousesUser;
            else{
              const res = await server.search("warehouses",filter);
              if (res.content.results) {
                state.warehouses = res.content.results;
              }else {state.warehouses = state.sous_warehouses = [];}
          }
          return  state.warehouses;
        }
    },
    getters: {
        warhouseSelected: (state) => async (data) => {
           if(!state.changeW){
                if(data.user && data.user.warehouses && data.user.warehouses.length>0) {   
                    if(data.user.warehouses.length==1) {
                        state.warhouseSelected=data.user.warehouses[0].country||data.user.warehouses[0];
                        localStorage.setItem('countryW', state.warhouseSelected);
                    }else{
                        //console.log('multiple ware----',localStorage.getItem('countryW'))
                       // console.log('data.user.warehouses ware----',data.user.warehouses)
                        //console.log('localStorage countryW----',localStorage.getItem('countryW'))
                        if(localStorage.getItem('countryW')){
                            const dataW=data.user.warehouses.find(o => o.country === localStorage.getItem('countryW'));
                           // console.log('dataW----',dataW)
                            if(!dataW) {
                                localStorage.setItem('countryW', data.user.warehouses[0].country||data.user.warehouses[0]);
                                //reduxStore.dispatch("actionCountry",{countryW:data.user.warehouses[0].country||data.user.warehouses[0]});
                              //  window.location.reload();
                            }
                        }else{
                            localStorage.setItem('countryW', data.user.warehouses[0].country||data.user.warehouses[0]);
                            reduxStore.dispatch("actionupdate",{update:true,pr_version:localStorage.getItem('pr-version')});
                        }
                    }
                    return localStorage.getItem('countryW') || data.user.warehouses[0].country||data.user.warehouses[0];
                }
           }
           
           return state.warhouseSelected;
        },
        sous_warhouseSelected: (state) => async (data) => {
            console.log('-------------------sous_warhouseSelected---------------')
            if(!state.changeW_sous){

                if(data.user && data.user.type && ['Seller', 'Admin','Administrateur','Subscription'].indexOf(data.user.type) != -1){
                    if(data.user && data.user.sous_warehouses && data.user.sous_warehouses.length>0) {   
                        // if(data.user.sous_warehouses.length==1) {
                        //     state.sous_warhouseSelected=data.user.sous_warehouses[0]._id.toString();
                        //     localStorage.setItem('sous_countryW', state.sous_warhouseSelected);
                        // }else{
                            //console.log('multiple ware----',localStorage.getItem('countryW'))
                           // console.log('data.user.warehouses ware----',data.user.warehouses)
                            //console.log('localStorage countryW----',localStorage.getItem('countryW'))
                            if(localStorage.getItem('sous_countryW')){
                                const dataW=data.user.sous_warehouses.find(o => o._id.toString() === localStorage.getItem('sous_countryW'));
                               // console.log('dataW----',dataW)
                                if(!dataW && localStorage.getItem('sous_countryW') != 'all') {
                                   localStorage.setItem('sous_countryW', data.user.sous_warehouses[0]._id.toString());
                                }
                            }else{
                                localStorage.setItem('sous_countryW', 'all'||data.user.sous_warehouses[0]._id.toString());
                                reduxStore.dispatch("actionupdate",{update:true,pr_version:localStorage.getItem('pr-version')});
                            }
                       // }
                        return localStorage.getItem('sous_countryW') || 'all' || data.user.sous_warehouses[0]._id.toString();
                    }
                }else state.sous_warhouseSelected= null;

            }
            
            return state.sous_warhouseSelected;
         },
        warehouses: (state) => async (data) => {
           // console.log('ttttttttttttttttttttttttttt',data)
           // return false
            const filter = {limit:1000};
            state.warehousesUser=[];
            state.warehouses=[];
            if (data.user){
                if(data.user.warehouses) state.warehousesUser = data.user.warehouses; 
                if(data.user.sous_warehouses && data.user.sous_warehouses.length>0) state.sous_warehouses = data.user.sous_warehouses;
            } 

            if(state.warehousesUser.length>0) state.warehouses= state.warehousesUser;
            else{
              const res = await server.search("warehouses",filter);
              if(res && res.content.results) {
                state.warehouses = res.content.results;
              }else {state.warehouses = state.sous_warehouses= [];}
          }
          console.log('warehouses__________________',state.warehouses)
          return  state.warehouses;
        }
       
    }
};